import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { EmailJobTrigger } from '@interfaces';
import { AppService } from '../../../../../../services';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, app: AppService): GridSetup<EmailJobTrigger & { updatedUTC: number }> {

	return {
		rowName: { singular: 'Email Job Trigger', plural: 'Email Job Triggers' },
		getRowKey: row => '' + row.jobTriggerId,
		stateKey: 'configuration-email-job-triggers-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util, app),
	}
}
